import { IEstateProperty } from "./mini-infocard-realestate-properties.component";
import { EVEstateType } from "src/models/units/unit-attributes.model";
import { AreaConverterPipe } from "src/app/shared/pipes/areaconverter";
import { DefaultConverterPipe } from "src/app/shared/pipes/defaultconverter.pipe";

export class EstatePorpertiesHelper {
    static getEstateProperties(keyInfo: any): IEstateProperty[] {
        const areaConverterPipe: AreaConverterPipe = new AreaConverterPipe();
        const defaultConverter: DefaultConverterPipe = new DefaultConverterPipe();
        const properties: IEstateProperty[] = [];
        const primaryAreaPosition = keyInfo.measuredPrimaryArea && !keyInfo.internalUsableArea ? "left" : "none";

        properties.push(this.createEstateProperty("BRA-i", keyInfo.internalUsableArea, "m²"));
        properties.push(this.createEstateProperty("BRA-e", keyInfo.externalUsableArea, "m²"));
        properties.push(this.createEstateProperty("BRA-b", keyInfo.glazedBalconyUsableArea, "m²"));
        properties.push(this.createEstateProperty("BRA", keyInfo.usableArea, "m²"));
        properties.push(this.createEstateProperty("BTA", keyInfo.grossArea, "m²"));
        properties.push(this.createEstateProperty("P-rom", keyInfo.measuredPrimaryArea, "m²", primaryAreaPosition));
        const plotArea = keyInfo.siteArea ?? keyInfo.siteAreaShared;
        properties.push(this.createEstateProperty("Tomt", areaConverterPipe.transform(plotArea, false, false), null));
        properties.push(this.createEstateProperty("Byggeår", keyInfo.buildYear, null, "right"));

        if (keyInfo.estateType === EVEstateType.Leilighet) {
            properties.push(
                this.createEstateProperty(
                    "Etasje",
                    defaultConverter.transform(this.concatFloorsForApartment(keyInfo.floor, keyInfo.numberOfFloors), null),
                    "",
                    "right"
                )
            );
            properties.push(this.createEstateProperty("Soverom", defaultConverter.transform(keyInfo.numberOfBedrooms, null), "", "right"));
        } else {
            properties.push(this.createEstateProperty("Etasjer", defaultConverter.transform(keyInfo.numberOfFloors, null), "", "right"));
            properties.push(this.createEstateProperty("Rom", defaultConverter.transform(keyInfo.numberOfBedrooms, null), "", "right"));
        }
        return properties;
    }

    private static createEstateProperty(
        heading: string,
        value: string | number,
        notation: string,
        position: "left" | "right" | "none" = "left"
    ): IEstateProperty {
        const v = value == null || value === 0 ? "-" : value;
        if (v === "-") {
            notation = "";
        }
        return {
            heading: heading,
            value: v,
            notation: notation,
            position: position,
        };
    }
    private static concatFloorsForApartment(floor?: number, numberOfFloors?: number): string {
        if (floor) {
            if (numberOfFloors) {
                return floor + " av " + numberOfFloors;
            } else {
                return floor + " av -";
            }
        } else {
            if (numberOfFloors) {
                return "- av " + numberOfFloors;
            }
            return "-";
        }
    }
}
